import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export default function Privacidad() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <section className="pt-32 pb-20 px-4">
        <div className="max-w-3xl mx-auto prose prose-slate">
          <h1 className="font-heading font-bold text-3xl text-municipal mb-2">Política de Privacidad</h1>
          <p className="text-sm text-gray-400 mb-8">Última actualización: 27 de julio de 2026</p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Responsable del tratamiento</h2>
          <p className="text-gray-600 leading-relaxed">
            El responsable del tratamiento de los datos personales recabados a través de este portal es el <strong>Ayuntamiento de
            San Fernando de Henares</strong>. El servicio de recogida es gestionado operativamente por <strong>Valoriza Servicios
            Medioambientales S.A.</strong> (NIF A28760692, Calle Condesa de Venadito 5, 28027 Madrid), en su condición de encargado
            del tratamiento. Contacto: <a href="mailto:protecciondatos.vsm@valorizasm.com" className="text-municipal underline">protecciondatos.vsm@valorizasm.com</a>.
            Delegado de Protección de Datos: <a href="mailto:dptopd.vsm@valorizasm.com" className="text-municipal underline">dptopd.vsm@valorizasm.com</a>.
          </p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Datos recabados y finalidad</h2>
          <p className="text-gray-600 leading-relaxed">
            Al completar el formulario de solicitud de recogida se recaban los siguientes datos: nombre completo, correo electrónico,
            teléfono y dirección. Estos datos se utilizan exclusivamente para gestionar tu solicitud de recogida de enseres o poda,
            contactar contigo en caso necesario y enviarte la confirmación y seguimiento de tu ticket.
          </p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Base jurídica</h2>
          <p className="text-gray-600 leading-relaxed">
            La base jurídica del tratamiento es el consentimiento expreso del usuario, prestado al marcar la casilla de aceptación
            en el formulario de solicitud.
          </p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Conservación y destinatarios</h2>
          <p className="text-gray-600 leading-relaxed">
            Los datos se conservarán durante el tiempo necesario para prestar el servicio solicitado y durante el plazo legal exigido
            para atender posibles responsabilidades. No se ceden datos a terceros salvo obligación legal. El envío de confirmaciones
            por email se realiza a través de un proveedor de mensajería transaccional bajo acuerdo de confidencialidad.
          </p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Derechos de los usuarios</h2>
          <p className="text-gray-600 leading-relaxed">
            Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a
            <a href="mailto:protecciondatos.vsm@valorizasm.com" className="text-municipal underline"> protecciondatos.vsm@valorizasm.com</a>,
            acreditando tu identidad. También puedes contactar con la Agencia Española de Protección de Datos (www.aepd.es) si consideras
            vulnerado tu derecho a la protección de datos.
          </p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Seguridad</h2>
          <p className="text-gray-600 leading-relaxed">
            El portal utiliza conexión cifrada (HTTPS/SSL) y medidas técnicas y organizativas adecuadas para proteger tus datos frente
            a accesos no autorizados, pérdida o alteración.
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
